/* eslint-disable import/prefer-default-export */

import { makeEntityScaffold } from '@classpass/saga-tools';

const NAMESPACE = 'SAGA.API.CMS';
const SPACES = {
  legal: 'legal',
  webContent: 'consumer_web_content',
  webData: 'consumer_web_data',
  webPage: 'consumer_web',
};

const pathMapping = [
  {
    path: '/',
    contentfulPath: '/homepage',
  },
  {
    path: /^(\/invite).*/,
    contentfulPath: '/invite',
  },
];

const getPathMapping = path => {
  const pathMap = pathMapping.find(mapping => (mapping.path.test ? mapping.path.test(path) : mapping.path === path));
  return (pathMap && pathMap.contentfulPath) || path;
};

export const cms = makeEntityScaffold(
  NAMESPACE,
  (client, path, options = {}) =>
    client.cms
      .getContentBySpace(SPACES.webPage, {
        path: getPathMapping(path),
        ...options,
      })
      .then(({ content }) => content),
  { defaultKey: (client, path) => getPathMapping(path) }
);

export const cmsLegalContent = makeEntityScaffold(
  `${NAMESPACE}.LEGAL_CONTENT`,
  (client, path, config = { transformToHTML: false }) =>
    client.cms
      .getContentBySpace(SPACES.legal, {
        path,
        transformToHTML: config.transformToHTML,
      })
      .then(({ content }) => content.data),
  { defaultKey: (client, path) => path }
);

export const cmsWebContent = makeEntityScaffold(
  `${NAMESPACE}.WEB_CONTENT`,
  (client, path, options = {}) =>
    client.cms
      .getContentBySpace(SPACES.webContent, {
        path,
        ...options,
      })
      .then(({ content }) => content),
  { defaultKey: (client, path) => path }
);

export const cmsWebData = makeEntityScaffold(
  `${NAMESPACE}.WEB_DATA`,
  (client, path, options = {}) =>
    client.cms
      .getContentBySpace(SPACES.webData, {
        path,
        ...options,
      })
      .then(({ content }) => content),
  { defaultKey: (client, path) => path }
);
